import { TASK_PRIORITY, type TaskPriority } from '@ovrsee/shared'

const COLOUR: Record<TaskPriority, string> = {
  [TASK_PRIORITY.HIGH]: 'var(--negative)',
  [TASK_PRIORITY.MEDIUM]: 'var(--warning)',
  [TASK_PRIORITY.LOW]: 'var(--fg-subtle)',
}

const LABEL: Record<TaskPriority, string> = {
  [TASK_PRIORITY.HIGH]: 'High priority',
  [TASK_PRIORITY.MEDIUM]: 'Medium priority',
  [TASK_PRIORITY.LOW]: 'Low priority',
}

/** Colour alone is not an accessible signal, so the dot carries a label. */
export function PriorityDot({ priority }: { priority: TaskPriority }) {
  return (
    <span
      role="img"
      aria-label={LABEL[priority]}
      style={{
        display: 'inline-block',
        width: 6,
        height: 6,
        borderRadius: '50%',
        background: COLOUR[priority],
        flexShrink: 0,
      }}
    />
  )
}
